<template>
  <div class="view-list">
    <div class="scroller">
      <SelectorOverlayContainer
        v-if="fertilizers.length"
        :value="id"
        :react-on="fertilizers"
        ref="overlay"
      >
        <SelectorOverlayItem
          v-for="item in fertilizers"
          :key="item.id"
        >
          <viewElement :data="item" :id="id"/>
        </SelectorOverlayItem>
      </SelectorOverlayContainer>
    </div>
  </div>
</template>

<script>
import ViewElement from "./View"
import { mapGetters } from 'vuex';
import {
  SelectorOverlayContainer,
  SelectorOverlayItem
} from '@/components/common/selector-overlay'

export default {
  components: {
    ViewElement,
    SelectorOverlayContainer,
    SelectorOverlayItem
  },
  computed: {
    ...mapGetters({
      fertilizers: 'fertilizers/getFertilizersAll',
      id: 'fertilizers/getId',
    }),
  }
}
</script>

<style lang="scss" scoped>
  .view-list {
    width: 100%;
    .scroller {
      overflow-y: auto;
      height: calc(100vh - 325px);
      scrollbar-width: thin;
    }
  }
</style>
